// Script to validate the date format DD/MM/YYYY
document.addEventListener('DOMContentLoaded', function() {
    let validatorInitialized = false;
    
    // Function to initialize the validator
    function initDateValidator() {
      // Check if already initialized
      if (validatorInitialized) return;
      
      // Select the date field using the 'child-date' class
      const dateContainer = document.querySelector('.child-date');
      if (!dateContainer) return;
      
      const dateInput = dateContainer.querySelector('input');
      if (!dateInput) return;
      
      // Check if messages container already exists
      let messagesContainer = dateContainer.querySelector('.date-validation-messages');
      if (messagesContainer) return; // Already initialized
      
      // Create a messages container
      messagesContainer = document.createElement('div');
      messagesContainer.className = 'date-validation-messages';
      messagesContainer.style.width = '100%';
      messagesContainer.style.marginTop = '5px';
      
      // Insert after the input's parent element or directly after input
      const inputWrap = dateInput.closest('.gpo-input-wrap');
      if (inputWrap) {
        inputWrap.parentNode.insertBefore(messagesContainer, inputWrap.nextSibling);
      } else {
        // Fallback: insert after the input
        dateInput.parentNode.insertBefore(messagesContainer, dateInput.nextSibling);
      }
      
      // Create an element to display the error message
      const errorMessage = document.createElement('div');
      errorMessage.className = 'error-message';
      errorMessage.style.color = '#e74c3c';
      errorMessage.style.fontSize = '12px';
      errorMessage.style.marginTop = '5px';
      errorMessage.style.display = 'none';
      messagesContainer.appendChild(errorMessage);
      
      // Function to validate the date format
      function validateDateFormat(value) {
        if (!value) return true; // Empty field is initially allowed
        
        // Regular expression for DD/MM/YYYY format
        const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        
        if (!dateRegex.test(value)) {
          return false;
        }
        
        // Additional validation to verify it's a valid date
        const parts = value.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months in JS are 0-11
        const year = parseInt(parts[2], 10);
        
        const date = new Date(year, month, day);
        
        return date.getDate() === day && 
               date.getMonth() === month && 
               date.getFullYear() === year;
      }
      
      // Format automatically while typing
      dateInput.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
        
        // Automatically add slashes
        if (value.length > 2) {
          value = value.substring(0, 2) + '/' + value.substring(2);
        }
        if (value.length > 5) {
          value = value.substring(0, 5) + '/' + value.substring(5, 9);
        }
        
        // Limit to 10 characters (DD/MM/YYYY)
        if (value.length > 10) {
          value = value.substring(0, 10);
        }
        
        e.target.value = value;
        
        // Validate format
        if (value.length === 10) {
          if (!validateDateFormat(value)) {
            errorMessage.textContent = 'Please enter a valid date in DD/MM/YYYY format';
            errorMessage.style.display = 'block';
          } else {
            errorMessage.style.display = 'none';
          }
        } else if (value.length > 0) {
          errorMessage.textContent = 'Complete the date in DD/MM/YYYY format';
          errorMessage.style.display = 'block';
        } else {
          errorMessage.style.display = 'none';
        }
      });
      
      // Validate when losing focus
      dateInput.addEventListener('blur', function(e) {
        const value = e.target.value;
        
        if (value && !validateDateFormat(value)) {
          errorMessage.textContent = 'Please enter a valid date in DD/MM/YYYY format';
          errorMessage.style.display = 'block';
          dateInput.classList.add('error');
        } else if (value) {
          errorMessage.style.display = 'none';
          dateInput.classList.remove('error');
        }
      });
      
      // Mark as initialized
      validatorInitialized = true;
    }
    
    // Try to initialize right away
    initDateValidator();
    
    // Also try after a slight delay in case elements are loaded dynamically
    setTimeout(initDateValidator, 1000);
    
    // And try one more time after a longer delay
    setTimeout(initDateValidator, 3000);
  });